import { TSysEmailStepDefinition } from '@commenda/types';
import { useWorkflow } from '../../context/WorkflowContext';
import { TSelectedEntity } from '../../types/node';
import { EmailConfigFields, TEmailConfig } from './EmailConfigFields';

export const SysEmailNodePropertyPanel = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow, setWorkflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  ) as TSysEmailStepDefinition | undefined;

  if (!selectedStep) return <div>Step not found</div>;

  const updateStep = (updates: Partial<TEmailConfig>) => {
    setWorkflow({
      ...workflow,
      steps: workflow?.steps.map((step) =>
        step.id === selectedEntity.id ? { ...step, ...updates } : step
      ),
    });
  };

  return (
    <EmailConfigFields
      fieldsKey={selectedEntity.id}
      ownerStepId={selectedEntity.id}
      config={selectedStep}
      onChange={updateStep}
    />
  );
};
